export const Roles = {
  Super_Administrator: "Super Administrator",
  District_Admin: "District Admin",
  School_Admin: "School Admin",
  ACT_Admin: "ACT Admin",
  ACT_Multi_District_Admin: "Organization Admin",
  Instructor: "Instructor",
  Teacher: "Teacher",
  Student: "Student",
  Sales_Rep: "Sales Rep",
  Course_Author: "Course Author"
}

export enum ModuleTypes {
  STUDY_HALL = "studyhall",
  PRACTICE_TESTING = "practice_testing",
  MASTERY_RESOURCES = "mastery_resources"
}

export enum TestCategory {
  PSAT,
  STAAR,
  ACT,
  EACT,
  DSAT,
  TSIA2
}

export const GroupType = {
  School: "School",
  Teacher: "Teacher",
  School_Admin: "School Admin",
  Instructor: "Instructor"
}

export const StorageLabel = {
  API_AUTH_TOKEN_KEY: "mp_id_token",
  USER: "user",
  USER_TOKEN: "user_token",
  IS_LOADER: "is_loader",
  STUDENTS: "students",
  NODES: "nodes",
  GROUP_UAS: "groupUAs",
  USER_ASSESSMENT: "userAssessment",
  EDUCATORS: "educators",
  STUDY_HALL_TEST: "studyHallTest",
  STUDY_HALL_Sort_Key: "sortKey",
  SP_LANDING_HELP: "sp_landing_help",
  SP_DEFAULT_INHERITANCE: "sp_default_inheritance",
  SP_MASTER_PLAN_INFO_VIEW: "sp_master_plan_info_view",
  EBOOK_GO_BACK_PAGE: "ebook_go_back_page"
}

export enum GradeLevelsEnum {
  DidNotTake = "Did not take",
  DidNotMeet = "Did not meet",
  Approaches = "Approaches",
  Meets = "Meets",
  Masters = "Master"
}

export enum AnnouncementTypeEnum {
  WHATS_NEW = "What's New",
  GENERAL = "General",
  ALERT = "Alert",
  TIP = "Tip",
  CUSTOM = "Custom",
  FEEDBACK_REQUEST = "Feedback Request",
  HELP_ARTICLES = "Help Articles",
  READY_TIP = "Ready Tip",
  PREP_TIP = "Prep Tip"
}

export enum AnnouncementLearnMoreEnum {
  MODAL = "Modal",
  LINK = "Link"
}

export enum FrequencyTypesEnum {
  PERSIST = "Persist",
  ONCE = "Once",
  HOURLY = "Hourly",
  DAILY = "Daily",
  WEEKLY = "Weekly"
}

export enum AlertToneTypesEnum {
  INFO = "Info",
  SUCCESS = "Success",
  WARNING = "Warning",
  ERROR = "Error"
}

export enum PlacementTypesEnum {
  TOP = "Top",
  BODY = "Body"
}

export enum AnnouncementStatusEnum {
  active = "active",
  inactive = "inactive"
}

export const EACT_STUDY_HALL_COURSE_NAME = "ACT-SR-1"
export const ACT_STUDY_HALL_COURSE_NAME = "SH-V1"
export const SAT_STUDY_HALL_COURSE_NAME = "SAT-SH-V1"
export const PSAT_STUDY_HALL_COURSE_NAME = "PSAT-SH-V1"
export const STAAR_STUDY_HALL_COURSE_NAME = "STAAR-SH-V1"

export const EACT_MASTERY_COURSE_NAME = "EACTM-C-V1"
export const ACT_MASTERY_COURSE_NAME = "ACTM-C-V2"
export const SAT_MASTERY_COURSE_NAME = "SATM-C-V1"
export const PSAT_MASTERY_COURSE_NAME = "PSATM-C-V1"
export const DSAT_MASTERY_COURSE_NAME = "DSATM-C-V1"
export const STAAR_MASTERY_COURSE_NAME = "STAARM-C-V1"
export const TSIA2_MASTERY_COURSE_NAME = "TSIA2M-C-V1"

export const studyHallCourseNamesByProgram = {
  act: ACT_STUDY_HALL_COURSE_NAME,
  eact: EACT_STUDY_HALL_COURSE_NAME,
  sat: SAT_STUDY_HALL_COURSE_NAME,
  psat: PSAT_STUDY_HALL_COURSE_NAME,
  staar: STAAR_STUDY_HALL_COURSE_NAME
}

export const masteryCourseNamesByProgram = {
  act: ACT_MASTERY_COURSE_NAME,
  eact: EACT_MASTERY_COURSE_NAME,
  sat: SAT_MASTERY_COURSE_NAME,
  psat: PSAT_MASTERY_COURSE_NAME,
  dsat: DSAT_MASTERY_COURSE_NAME,
  staar: STAAR_MASTERY_COURSE_NAME,
  tsia2: TSIA2_MASTERY_COURSE_NAME
}
